import { SvgIconProps, SvgIcon } from "@mui/material";

export const RedcandleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 288 288">
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="-0.01 0.005 109.504 149.497"
      viewBox="-0.01 0.005 109.504 149.497"
      xmlns="http://www.w3.org/2000/svg"
      data-type="color"
      role="img"
    >
      <g>
        <path
          d="M45.64 17.9a18.43 18.43 0 0 0 .44 2.1v.12A18.51 18.51 0 0 0 48 24.5l.09.15a18.1 18.1 0 0 0 2.45 3.2A8.45 8.45 0 0 1 54.06 21a1.17 1.17 0 0 1 1.34 0 8.45 8.45 0 0 1 3.6 6.85 18.59 18.59 0 0 0 2.45-3.2l.09-.15a18.94 18.94 0 0 0 1.84-4.34v-.12a18.43 18.43 0 0 0 .44-2.14v-.36a19.79 19.79 0 0 0 .18-2.32v-.07A18.55 18.55 0 0 0 56.54.24a1.21 1.21 0 0 0-1.92.85 18.66 18.66 0 0 1-9.12 14l-.07.11a17.84 17.84 0 0 0 .16 2.32c.01.14.03.26.05.38z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
        <path
          d="M11.05 84.08a1.3 1.3 0 0 0-1.4 1.32v2.19q0 10.18-.78 20.19-1 12.82-3.12 25.29a1.28 1.28 0 0 0 1.16 1.51q6.5.58 13 1a3 3 0 0 0 3.11-2.44q2.07-11.9 3.06-24.15.95-11.76.86-23.81c-5.3-.28-10.6-.66-15.89-1.1z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
        <path
          d="M99.8 87.59V85.4a1.31 1.31 0 0 0-1.41-1.32c-5.29.44-10.59.82-15.92 1.09q-.1 12 .85 23.81 1 12.14 3 23.94a3.21 3.21 0 0 0 3.36 2.64q6.44-.42 12.83-1a1.29 1.29 0 0 0 1.16-1.51q-2.16-12.45-3.13-25.29c-.47-6.65-.74-13.38-.74-20.17z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
        <path
          d="M58.53 43.61v5.7a2.62 2.62 0 0 0 2.66 2.62h3.61c3.89-.07 7.77-.2 11.63-.35 2.14-.09 4.27-.18 6.4-.29A2.61 2.61 0 0 0 85.28 49q.47-3.16 1-6.31c.33-2 .69-3.92 1.06-5.86a1.17 1.17 0 0 0-1.21-1.39q-4.2.26-8.42.43c-3.38.15-6.77.29-10.16.37-3 .07-6 .09-9 .11z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
        <path
          d="M24.19 49a2.61 2.61 0 0 0 2.44 2.24c2.19.11 4.37.21 6.56.29q5.81.24 11.63.35l3.63.06a2.64 2.64 0 0 0 2.65-2.63v-13c-3 0-6 0-9-.11-3.4-.08-6.78-.22-10.16-.36q-4.3-.18-8.59-.44a1.17 1.17 0 0 0-1.21 1.39c.38 1.94.73 3.9 1.06 5.86s.68 4.24.99 6.35z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
        <path
          d="M101.41 58.38c-5.8.5-11.63.94-17.48 1.26-2.67.14-5.35.25-8 .35q-6.16.25-12.37.35c-1.66 0-3.33 0-5 .06-1.27 0-2.53.05-3.8.05h-3.63l-5-.07q-6.2-.09-12.36-.34c-2.74-.11-5.47-.21-8.19-.36-5.86-.32-11.68-.76-17.49-1.26-2.18-.19-4.35-.41-6.52-.63A1.39 1.39 0 0 0 0 59.33c.31 2.24.58 4.48.88 6.73s.61 4.38.87 6.58a3 3 0 0 0 2.65 2.62c1.66.16 3.33.31 5 .45 5.77.49 11.56.92 17.38 1.22 2.51.13 5 .21 7.54.31 0 2.74.09 5.48.1 8.23v2.12c0 7.28-.18 14.53-.48 21.74q-.57 13.55-1.77 26.91-.51 5.65-1.15 11.27a1.4 1.4 0 0 0 1.33 1.55c5.73.24 11.49.38 17.31.44a1.42 1.42 0 0 0 1.42-1.41V77.62h7.43v70.47A1.42 1.42 0 0 0 60 149.5q8.68-.09 17.31-.44a1.4 1.4 0 0 0 1.33-1.56q-.65-5.61-1.15-11.26-1.23-13.37-1.77-26.91-.47-10.81-.48-21.74v-2.13q0-4.12.11-8.23c2.46-.09 4.92-.17 7.37-.3 5.82-.3 11.61-.73 17.38-1.22l5.22-.47a2.67 2.67 0 0 0 2.39-2.37c.26-2.29.6-4.54.9-6.81s.56-4.49.87-6.73a1.39 1.39 0 0 0-1.52-1.58c-2.2.25-4.37.44-6.55.63z"
          fill="#F2EEEB"
          data-color="1"
        ></path>
      </g>
    </svg>{" "}
  </SvgIcon>
);
